import { Card, Input ,Form, Button, message, Descriptions, Spin} from 'antd';
import { useEffect, useState } from 'react';
import { BsesApiService } from '../ApiService/BsesService';
import "./index.css"

const ConsumerPaymentCard = (props) =>{
    
    const [form] = Form.useForm()
    const [payAmount, setPayAmount] = useState()
    const [due_amount, setDueAmount] = useState(parseFloat(props.consumerData.amount))
    const [validatedAmount, setValidatedAmount] = useState(parseFloat(props.consumerData.amount))
    const [payloader, setPayloader] = useState(false)


    useEffect(() => {
        form.setFieldsValue({
            amount: props.consumerData.amount
        })
        setPayAmount(parseFloat(props.consumerData.amount))
        setDueAmount(parseFloat(props.consumerData.amount))
    }, [props.consumerData.amount]);

    const pay_amount_backend =  async() => {
        setPayloader(true)
        const payload = {
            ca : props.consumerData?.ca_number,
            inv : props.consumerData?.invoice_number,
            amount : form.getFieldValue('amount')
        }
        const response = await BsesApiService.payBill(payload)
        if (response.status){
            window.open(response.data?.redirect_url, "_self")
            setPayloader(false) 
        }
        else{
            message.error(response?.message)
            setPayloader(false) 
        }
        // setPayloader(false) 
    }

    return(<>
        <div className='main-wrapper' style={{ display: 'grid',placeItems: 'center',height:"100vh"}}>
            <div class="centered-div">
            <Card className="custom-card" cover={
    <div className='logo-main'>
      <img
        alt="BSES"
        className='bses-logo'
        src="https://ebz-static.s3.ap-south-1.amazonaws.com/easebuzz-static/bses_logo_v4.svg"
      />
      <img
        alt="Another Image"
        className='bob-logo'
        src="https://ebz-static.s3.ap-south-1.amazonaws.com/easebuzz-static/bank_of_baroda_logo_v4.svg"
      />
    </div>
  }>                 <div className='descriptions-details'>  
                    <Descriptions colon={false}>
                        <Descriptions.Item label="CA Number">{props.consumerData?.ca_number}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions colon={false}>
                        <Descriptions.Item label="Consumer Name">{props.consumerData?.consumer_name}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions colon={false}>
                        <Descriptions.Item label="Amount"><span>&#8377;&nbsp;</span>{props.consumerData?.amount}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions colon={false}>
                        <Descriptions.Item label="Company">{props.consumerData?.company}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions colon={false}>
                        <Descriptions.Item label="Bill date">{props.consumerData?.bill_date}</Descriptions.Item>
                    </Descriptions>
                    <Descriptions colon={false}>
                        <Descriptions.Item label="Due date">{props.consumerData?.due_date}</Descriptions.Item>
                    </Descriptions>
                    </div>
                <Form 
                form={form}
                onFinish={pay_amount_backend}
                >
                    <Form.Item  
                        name="amount"
                        rules={[{required : true, message: 'Please Enter amount to be paid'},()=>({
                            validator(_,pay_amount){
                                const regexPattern = /^\d+(\.\d{1,2})?$/
                                if (pay_amount && pay_amount.length === 1 && pay_amount === "0"){
                                    setPayAmount("")
                                    return false
                                }
                                if (pay_amount && !(regexPattern.test(pay_amount))) {
                                    return Promise.reject("Enter valid amount")
                                }
                                else if(pay_amount && pay_amount<due_amount){
                                    return Promise.reject("Amount can't be less than Due Amount")
                                }
                                return Promise.resolve();
                            }
                        })]}
                    >
                                <div type="text" style={{marginTop:"25px"}}>
                                    <div>
                                        <span>Payable Amount <sup style={{color:'red'}}>*</sup></span><span>
                                        <Input disabled={!props.showPaymentOptions} prefix={<span>&#8377;</span>} value={payAmount} placeholder="Enter Payment Amount" onChange={(e) => setPayAmount(e.target.value)} style={{ cursor: "pointer" }}>
                                        </Input></span>
                                        <p style={{fontSize:"12px",color:"#8F93A8"}}>*The amount cannot be less than the above mentioned Bill Amount</p>
                                    </div>
                                </div>
                    </Form.Item>

                    <Form.Item >
                        <Button  block  htmlType="submit" style={{ background: "#D62E26", color: "#ffff", marginTop: "15px" ,height:"40px"}} disabled={payloader} >
                        {payloader ? <Spin size="small" /> : <b>Pay Now</b>}
                        </Button>
                    </Form.Item>
                   
                </Form>
                
            </Card>
            <div  style={{margin:"20px auto", textAlign:"center"}}> 
                <img alt='footer_logo' src={"https://ebz-static.s3.ap-south-1.amazonaws.com/logo/EBZ-Powered-By-V3.svg"} />
            </div>
            </div>
        </div>
        </>)
}

export default ConsumerPaymentCard;